import { OverviewView } from "./_components";

export default function OverviewPage() {
  return <OverviewView />;
}
